import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=37041510&"
import script from "./Termos.vue?vue&type=script&lang=js&"
export * from "./Termos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports